import { createContext, useCallback, useContext, useState } from 'react';
import _ from 'lodash';
import WMICRiskPublicIdUtil from './WMICRiskPublicIdUtil';
import CONSTANTS, { RISK_PATHS } from './StringConstants';

const { WIZARD_ACTION_TYPES } = CONSTANTS;

const CanJumpToWizardStepDispatchContext = createContext(null);

export function CanJumpToWizardStepProvider({
    canJumpToWizardStepState,
    setCanJumpToWizardStepState,
    clearVisitedStepsAfterCurrent,
    children,
}) {
    const [startingRiskPublicIds, setStartingRiskPublicIds] = useState([]);

    const initDispatch = useCallback(
        vm => {
            if (startingRiskPublicIds.length === 0) {
                setStartingRiskPublicIds(
                    WMICRiskPublicIdUtil.getAllRiskPublicIds(
                        _.get(vm.value, RISK_PATHS.DWELLINGS_PATH),
                        _.get(vm.value, RISK_PATHS.WATERCRAFT_PATH),
                        _.get(vm.value, RISK_PATHS.VEHICLES_PATH),
                        _.get(vm.value, RISK_PATHS.DRIVERS_PATH)
                    )
                );
            }
        },
        [startingRiskPublicIds]
    );

    const canJumpToWizardStep = useCallback(
        action => {
            const setNewState = allowUserToJumpForward => {
                const newState = {
                    allowUserToJumpForward,
                    targetStep: canJumpToWizardStepState.targetStep,
                };
                canJumpToWizardStepState.allowUserToJumpForward = allowUserToJumpForward;
                setCanJumpToWizardStepState(newState);
                clearVisitedStepsAfterCurrent(newState);
            };

            // eslint-disable-next-line default-case
            switch (action.type) {
                case WIZARD_ACTION_TYPES.EFF_DATE_CHANGED:
                case WIZARD_ACTION_TYPES.RISK_ADDED: {
                    setNewState(false);
                    break;
                }
                case WIZARD_ACTION_TYPES.VALIDATE_PAGE: {
                    clearVisitedStepsAfterCurrent(canJumpToWizardStepState);
                    break;
                }
                case WIZARD_ACTION_TYPES.RESET: {
                    const doNewAndOldRiskPublicIdsMatch = WMICRiskPublicIdUtil.doNewAndOldRiskPublicIdsMatch(
                        startingRiskPublicIds,
                        _.get(action.vm.value, RISK_PATHS.DWELLINGS_PATH),
                        _.get(action.vm.value, RISK_PATHS.WATERCRAFT_PATH),
                        _.get(action.vm.value, RISK_PATHS.VEHICLES_PATH),
                        _.get(action.vm.value, RISK_PATHS.DRIVERS_PATH)
                    );

                    if (doNewAndOldRiskPublicIdsMatch) {
                        setNewState(true);
                    }
                    break;
                }
                case WIZARD_ACTION_TYPES.QUOTED: {
                    setNewState(true);
                    break;
                }
            }
        },
        [canJumpToWizardStepState, setCanJumpToWizardStepState, clearVisitedStepsAfterCurrent]
    );

    const canJumpToWizardStepProps = {
        initDispatch,
        wizardStepDispatch: canJumpToWizardStep,
    };

    return (
        <CanJumpToWizardStepDispatchContext.Provider value={canJumpToWizardStepProps}>
            {children}
        </CanJumpToWizardStepDispatchContext.Provider>
    );
}

export function useCanJumpToWizardStepDispatch() {
    return useContext(CanJumpToWizardStepDispatchContext);
}
